export default class Category {
  name: string = "";
  id: string = "";
}
